// extracted by mini-css-extract-plugin
export default {"margin":"xaPFf4LRIXQ_YDia","headingCell":"EuT4Oto7awef4TiW","rateCell":"PEhPOb_rFNEGnr3b"};